import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MarqueeBand } from "@/components/MarqueeBand";
import { Features } from "@/components/Features";
import { Pricing } from "@/components/Pricing";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Testimonials } from "@/components/Testimonials";
import { AppJourney } from "@/components/AppJourney";
import { Footer } from "@/components/Footer";
import { FloatingCTA } from "@/components/FloatingCTA";
import { BackToTop } from "@/components/BackToTop";
import { ChatWidget } from "@/components/ChatWidget";
import { Seo } from "@/components/Seo";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const lenis = useLenis();
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function Home() {
  return (
    <main>
      <Seo
        title="Syndicappli360 — Application de gestion de copropriété"
        description="Facilitez la vie en copropriété : messagerie instantanée, AG en visioconférence à 360°, vote électronique sécurisé, suivi d'incidents. Démo de 30 min reservable."
        path="/"
      />
      <Hero />
      <MarqueeBand />
      <Features />
      <AppJourney />
      <Pricing />
      <Testimonials />
      <Faq />
      <Contact />
    </main>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ReactLenis
          root
          options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}
        >
          <div className="grain bg-paper font-sans text-ink">
            <Navbar />
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route
                path="/politique-de-confidentialite"
                element={<PolitiqueConfidentialite />}
              />
              <Route path="*" element={<NotFound />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <Footer />
            <FloatingCTA />
            <BackToTop />
            <ChatWidget />
            <Toaster position="bottom-center" richColors />
          </div>
        </ReactLenis>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
